// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"j2-z","subtitle":"k2-z","wrapper":"l2-z","leftArrow":"m2-z","rightArrow":"n2-z"};